export const anexoMessagesEnum = {
  ADD_TITLE: {
    fase: 'Adicione um ou mais anexos à sua fase',
    tarefa: 'Adicione um ou mais anexos à sua tarefa'
  },
  EMPTY: {
    processo: 'Não há anexo para este processo.',
    fase: 'Não há anexo para esta fase.',
    tarefa: 'Não há anexo para esta tarefa.'
  }
};
